import React from 'react';
import { G, Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarUserBoldIcon: React.FC<IconProps> = ({ size = 32 , color}) => {
  const COLOR = color ||'#FDFDFD';
  return(

    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <G id="User">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.3327 16.0003C29.3327 23.3641 23.3631 29.3337 15.9993 29.3337C8.63555 29.3337 2.66602 23.3641 2.66602 16.0003C2.66602 8.63653 8.63555 2.66699 15.9993 2.66699C23.3631 2.66699 29.3327 8.63653 29.3327 16.0003ZM19.9993 12.0003C19.9993 14.2095 18.2085 16.0003 15.9993 16.0003C13.7902 16.0003 11.9993 14.2095 11.9993 12.0003C11.9993 9.79119 13.7902 8.00033 15.9993 8.00033C18.2085 8.00033 19.9993 9.79119 19.9993 12.0003ZM15.9993 27.3337C18.3781 27.3337 20.5856 26.6008 22.4086 25.3486C23.2137 24.7955 23.5578 23.742 23.0897 22.8846C22.1193 21.1073 20.1197 20.0003 15.9993 20.0003C11.8789 20.0003 9.87931 21.1073 8.90887 22.8845C8.44074 23.7419 8.78482 24.7954 9.58996 25.3485C11.4129 26.6008 13.6205 27.3337 15.9993 27.3337Z"
          fill={COLOR}
        />
      </G>
    </Svg>
  );};

